/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/shop/dialogs/scan2warenkorb/shop.dialogs.scan2warenkorb.component.ts.
 */
import {Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {AppPageloaderService} from '../../../../services/app.pageloader.service';
import {AppMessageService} from '../../../../services/app.message.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Warenkorb} from '../../../../models/warenkorb';
import {AppWarenkorbService} from '../../../../services/app.warenkorb.service';
import {AppShopService} from '../../../../services/app.shop.service';
import {BehaviorSubject} from 'rxjs';
import {AppSearchService} from '../../../../services/app.search.service';
import {Artikel} from '../../../../models/artikel';
import {WarenkorbEntry} from '../../../../models/warenkorb-entry';
import {AppMemoryService} from '../../../../services/app.memory.service';
import {PageloaderObject} from '../../../../models/pageloader-object';

/**
 * Zweck: Beschreibt class ShopDialogsScan2warenkorbComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'shop.dialogs.scan2warenkorb.component.html',
    styleUrls: ['shop.dialogs.scan2warenkorb.component.scss'],
    standalone: false
})
export class ShopDialogsScan2warenkorbComponent implements OnInit, OnDestroy {
  id: number;

  warenkorbId: number;

  selectedWarenkorb: Warenkorb;

  searchValue: any = '';

  lastAddedArticles = new BehaviorSubject<Artikel[]>([]);

  searchArticles = new BehaviorSubject<Artikel[]>([]);

  showResults = new BehaviorSubject<boolean>(false);

  error = new BehaviorSubject<string>(null);

  lastAddedArticlesLimit = 5;

  amount = 1;

  force = false;

  searchImport = false;

  searchQuery: any;

  @ViewChild('input') searchBox;

  keyDownSearchTimeout: any;

  searchLoader: PageloaderObject;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public dialogRef: MatDialogRef<ShopDialogsScan2warenkorbComponent>,
              @Inject(MAT_DIALOG_DATA) public data:
              {
                importId: number,
                warenkorbId: number,
              }, private svc: AppSearchService, private memsvc: AppMemoryService,
              private loader: AppPageloaderService, private ssvc: AppShopService,
              private msg: AppMessageService, private wksvc: AppWarenkorbService) {
  }

/**
 * Beschreibt Methode forceChange und ihren Rückgabevertrag.
 */
  forceChange() {
    this.memsvc.set('ShopDialogsScan2warenkorbComponent_force', this.force);
  }


/**
 * Beschreibt Methode changeImport und ihren Rückgabevertrag.
 */
  changeImport() {
    this.memsvc.set('ShopDialogsScan2warenkorbComponent_searchImport', this.searchImport);
  }

/**
 * Beschreibt Methode showArtLabel und ihren Rückgabevertrag.
 */
  showArtLabel(art) {
    if (art) {
      return art.bezeichnung;
    } else {
      return art;
    }
  }

/**
 * Beschreibt Methode selectedArticleOption und ihren Rückgabevertrag.
 */
  selectedArticleOption(ev) {
    if (this.searchValue instanceof Artikel) {
      this.selectArticle(this.searchValue);
    }
  }

/**
 * Beschreibt Methode selectArticle und ihren Rückgabevertrag.
 */
  selectArticle(article: Artikel) {
    this.searchArticles.next([]);
    const entry = new WarenkorbEntry();
    entry.menge = this.amount;
    entry.artikel = article;
    entry.view_slug = article.view.slug;

    this.amount = 1;

    const lastAddedArticles = this.lastAddedArticles.value;
    lastAddedArticles.unshift(entry.artikel);
    if (lastAddedArticles.length > this.lastAddedArticlesLimit) {
      lastAddedArticles.pop();            // letztes Element entfernen
    }
    this.lastAddedArticles.next(lastAddedArticles);

    this.ssvc.addToWarenkorb(this.selectedWarenkorb, entry, () => {
      this.searchValue = '';

    }, this.force);
  }

/**
 * Beschreibt Methode keyDownSearch und ihren Rückgabevertrag.
 */
  keyDownSearch() {
    if (this.keyDownSearchTimeout) {
      clearTimeout(this.keyDownSearchTimeout);
    }
    if (this.searchQuery) {
      this.searchLoader.stop();
      this.searchQuery.unsubscribe();
    }
    this.keyDownSearchTimeout = setTimeout(() => {
      this.search();
    }, 500);
  }

/**
 * Verhindert, dass Scanner-Tastenkürzel im Suchfeld den Browser-Zoom verändern.
 */
  preventBrowserZoom(event: KeyboardEvent): void {
    if (!event.ctrlKey || event.altKey) {
      return;
    }

    const zoomShortcut = event.key === '+' || event.key === '-' || event.key === '=' ||
      event.code === 'BracketRight' || event.code === 'NumpadAdd' ||
      event.code === 'Equal' || event.code === 'Minus' || event.code === 'NumpadSubtract';

    if (zoomShortcut) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

/**
 * Beschreibt Methode search und ihren Rückgabevertrag.
 */
  search() {
    if (typeof this.searchValue != 'object') {
      if (this.searchValue.length <= 3 && !isNaN(this.searchValue)) {
        if (this.searchValue >= 1) {
          this.amount = parseInt(this.searchValue);
        } else {
          this.searchValue = 1;
        }
        this.searchValue = '';
      } else {
        if (this.searchQuery) {
          this.searchQuery.unsubscribe();
        }
        this.showResults.next(true);
        this.searchLoader = this.loader.start();

        this.error.next(null);

        let filterArtikelstamm = null;

        if (!this.searchImport) {
          filterArtikelstamm = 'AT';
        }

        this.searchQuery = this.svc.articleSearch(this.searchValue, [], filterArtikelstamm).subscribe({
          next: (res) => {
            if (res.length > 1) {
              this.searchArticles.next(res);

            } else if (res.length == 1) {
              this.selectArticle(res[0]);

            } else {
              this.error.next('Nicht gefunden!');
              this.searchValue = '';
            }
            this.searchLoader.stop();
          },
          error: (e) => {
            this.searchLoader.stop();
          }
        });
      }
    }
  }

/**
 * Beschreibt Methode close und ihren Rückgabevertrag.
 */
  close() {
    this.dialogRef.close();
  }


/**
 * Beschreibt Methode ngOnDestroy und ihren Rückgabevertrag.
 */
  ngOnDestroy(): void {
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    setTimeout(() => {
      this.searchBox.nativeElement.focus();
    }, 200);

    if (this.memsvc.has('ShopDialogsScan2warenkorbComponent_force')) {
      this.force = this.memsvc.get('ShopDialogsScan2warenkorbComponent_force');
    }

    if (this.memsvc.has('ShopDialogsScan2warenkorbComponent_searchImport')) {
      this.searchImport = this.memsvc.get('ShopDialogsScan2warenkorbComponent_searchImport');
    }

    if (this.data.warenkorbId) {
      this.warenkorbId = this.data.warenkorbId;
      this.wksvc.warenkoerbe.value.some(wk => {
        if (wk.id == this.warenkorbId) {
          this.selectedWarenkorb = wk;
          return true;
        } else {
          return false;
        }
      });

    } else {
      this.selectedWarenkorb = this.wksvc.primary_warenkorb.value;
    }
  }
}
